import find from 'lodash/find';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import some from 'lodash/some';
import logger from '../../../logging/logger';
import googlePal from '../../../targeting/palSdkController';
import { State, getState } from '../../../utils/applicationState';
import adSlotManager from '../../adSlotManager';
import reporter from '../../reporter';
import Events from '../../media/Events';
import CompanionAdManager from '../../media/companions/CompanionAdManager';
import CompanionCache from '../../media/companions/CompanionCache';
import companionEvents from '../../media/companions/companionEvents';
import mediaEvents from '../../media/mediaEvents';
import { INSTREAM_AD_COMPANION_ERROR, INSTREAM_COMPANION_AD_CLICKED, } from '../../../logging/constants';
import { Networks } from '../../../utils/constants';
const devAdUnitIds = {
    side: '15480783/Dev.Gemini/dev.instream_banner_side',
    top: '15480783/Dev.Gemini/dev.instream_banner_top',
    audio: '15480783/Dev.Gemini/dev.instream_audio',
};
const prodAdUnitIds = {
    side: '15480783/Gemini/instream_banner_side',
    top: '15480783/Gemini/instream_banner_top',
    audio: '15480783/Gemini/instream_audio',
};
export default class InstreamCompanionController {
    constructor() {
        this.audioSlotData = {};
        this.currentAdRequestId = '';
        this.companionModelSlots = [];
        this.companionAdManager = new CompanionAdManager(new CompanionCache());
        this.companionAdManager.on(companionEvents.loaded, this.onCompanionLoaded);
        this.companionAdManager.on(companionEvents.clicked, this.onCompanionAdClick);
        const env = getState(State.env);
        this.adUnitIds = env === 'production' ? prodAdUnitIds : devAdUnitIds;
    }
    destroy = () => {
        if (this.companionAdManager) {
            this.companionAdManager.off(companionEvents.loaded, this.onCompanionLoaded);
            this.companionAdManager.off(companionEvents.clicked, this.onCompanionAdClick);
        }
        this.resetCompanionsIfNeeded();
    };
    set = (property, value) => {
        this[property] = value;
    };
    resetCompanionsIfNeeded = () => {
        if (this.companionModelSlots.length < 1) {
            return;
        }
        logger.debug('resetCompanionsIfNeeded');
        forEach(this.companionModelSlots, (slot) => {
            const displaySlot = adSlotManager.getSlot(slot.elementId);
            if (displaySlot) {
                displaySlot.refresh();
            }
        });
        this.companionModelSlots = [];
    };
    refreshUnusedSlots = (companions, displaySlots) => {
        forEach(displaySlots, (slot) => {
            const slotWidth = get(slot, 'currentDimensions[0]');
            const slotHeight = get(slot, 'currentDimensions[1]');
            const hasNewCompanion = some(companions, (c) => slotWidth === c.width && slotHeight === c.height);
            if (!hasNewCompanion) {
                slot.refresh();
            }
        });
    };
    mapCompanionData = (companionAdData) => {
        return companionAdData.map((companion) => {
            const trackingEvent = find(companion.trackingEvents, (te) => te.eventType === 'creativeView');
            const trackingPixel = get(trackingEvent, 'beaconUrls[0]', '');
            return {
                width: get(companion, 'attributes.width'),
                height: get(companion, 'attributes.height'),
                content: {
                    isInstream: true,
                    staticResource: companion.staticResource,
                    htmlResource: companion.htmlResource,
                    companionClickThrough: companion.companionClickThrough,
                    companionClickTracking: companion.companionClickTracking,
                    trackingPixel,
                },
            };
        });
    };
    handleCompanionAds = (ad) => {
        const { companionAds } = ad;
        if (companionAds.length < 1) {
            logger.debug('There are no companions for this ad.');
            this.adProvider = Networks.dfp;
            this.resetCompanionsIfNeeded();
            return;
        }
        const displaySlots = adSlotManager.getDisplaySlots();
        const adProvider = get(displaySlots, '[0].formatDefinition.adProvider');
        if (!adProvider) {
            this.adProvider = 'unknown';
            return;
        }
        this.adProvider = adProvider;
        const companions = this.mapCompanionData(companionAds);
        if (this.companionModelSlots.length > companionAds.length) {
            this.refreshUnusedSlots(companions, displaySlots);
        }
        this.companionModelSlots = [];
        try {
            this.companionAdManager.processCompanionAds(companions, displaySlots, adProvider);
        }
        catch (ex) {
            logger.error({
                message: INSTREAM_AD_COMPANION_ERROR,
                error: ex,
                data: reporter.getParameters(this.audioSlotData),
            });
        }
    };
    onCompanionLoaded = (companionSlot) => {
        if (!companionSlot) {
            return;
        }
        this.companionModelSlots.push(companionSlot);
    };
    onCompanionAdClick = (slot) => {
        if (!slot) {
            return;
        }
        const instreamSlotData = this.getInstreamSlotData(slot);
        mediaEvents.event(Events.Media.display, Events.Status.click).emit({
            slot: instreamSlotData,
            isInstream: true,
            isCompanionAd: true,
        });
        reporter.click(instreamSlotData);
        googlePal.reportAdClick();
        logger.info({
            message: INSTREAM_COMPANION_AD_CLICKED,
            data: reporter.getParameters(instreamSlotData),
        });
    };
    showCompanionAds = () => {
        if (this.companionModelSlots.length < 1) {
            return;
        }
        forEach(this.companionModelSlots, (companionSlot) => this.showCompanionAd(companionSlot));
    };
    showCompanionAd = (companionSlotModel) => {
        const { elementId, name, format, width, height, content } = companionSlotModel;
        if (!(elementId && name && format && width && height && content)) {
            return;
        }
        const mintSlot = adSlotManager.getSlot(elementId);
        if (!mintSlot) {
            return;
        }
        const slotElement = global.document.getElementById(elementId);
        if (!slotElement) {
            return;
        }
        mintSlot.requestId = this.currentAdRequestId;
        mintSlot.formatDefinition = format;
        mintSlot.currentDimensions = [width, height];
        logger.info({
            message: 'show.companion.ad.debug.dimensions.issue',
            data: {
                currentDimensions: [width, height],
            },
        });
        try {
            if (mintSlot.adTypeController) {
                mintSlot.adTypeController.deregisterSlot(mintSlot);
                mintSlot.adTypeController.releaseSlot(mintSlot);
            }
            this.companionAdManager.renderCompanionAd(slotElement, mintSlot, width, height, content);
            adSlotManager.addCompanionSlot(mintSlot);
            const slotData = this.getInstreamSlotData(mintSlot);
            reporter.impression(slotData);
            logger.debug('Instream Companion Ad Rendered/Impression.');
        }
        catch (ex) {
            const slotData = this.getInstreamSlotData(companionSlotModel);
            mediaEvents.event(Events.Media.display, Events.Status.failed).emit({
                slot: slotData,
                errorCode: '',
                errorMessage: '',
                debugDescription: 'Display Ad, Companion Ad via showCompanionAd',
            });
            logger.error({
                message: INSTREAM_AD_COMPANION_ERROR,
                error: ex,
                data: reporter.getParameters(slotData),
            });
        }
    };
    getDisplayUnitId = (slot) => {
        const slotName = slot.name || '';
        if (slotName.indexOf('top') > -1) {
            return this.adUnitIds.top;
        }
        if (slotName.indexOf('side') > -1) {
            return this.adUnitIds.side;
        }
        return 'instream_unknown';
    };
    getInstreamSlotData = (slot) => {
        const slotUnitId = this.getDisplayUnitId(slot);
        return {
            ...slot,
            formatDefinition: {
                adProvider: this.adProvider,
                adUnitId: slotUnitId,
            },
        };
    };
}
